module.exports = __webpack_public_path__ + "img/tddg-7.4df9ef3b.jpg";